import { Directive, HostListener, Input } from '@angular/core';

declare var $: any;
@Directive({
  selector: '[fixed-header]'
})
export class FixedheaderDirective {
  // fixThead(listLength) {
  //   if ($('thead tr:nth-child(2) th').length > 0) {
  //     let array_tr1 = [];
  //     $('thead tr:nth-child(1) th').each(function (index) {
  //       if ($(this).attr("colspan") <= 0 || $(this).attr("colspan") == undefined) {
  //         array_tr1.push({ index: index, colspan: "0" });
  //       }
  //       else {
  //         array_tr1.push({ index: index, colspan: $(this).attr("colspan") })

  //       }
  //     });
  //     let item_index_header = 0;
  //     array_tr1.forEach(element => {
  //       if (element.colspan != "0") {
  //         let index_tr_2 = 0;
  //         $('thead tr:nth-child(2) th').each(function (index) {
  //           if ($(this).attr('class').indexOf("added-width") <= 0 && index_tr_2 < parseInt(element.colspan)) {
  //             $(this).width(listLength[item_index_header + index_tr_2].width);
  //             $(this).addClass("added-width " + (item_index_header + index_tr_2));
  //             index_tr_2 += 1;
  //           }
  //           else {
  //             return;
  //           }
  //         });
  //         item_index_header += parseInt(element.colspan);
  //       }
  //       else {
  //         item_index_header += 1;
  //         $('thead tr:nth-child(1) th').each(function (index) {
  //           if (element.index == index) {
  //             $(this).width(listLength[item_index_header - 1].width);
  //           }
  //         });
  //       }
  //     });
  //   }
  //   else {
  //     $('thead tr:nth-child(1) th').each(function (index) {
  //       $(this).width(listLength[index].width);
  //     });
  //   }
  // }

  @Input() top: number = 55; // khoảng cách từ cạnh trên màn hình tới bảng, khi bảng di chuyển tới vị trí này thì bắt đầu fix header
                                    // mặc định là 55 = height của phần header
  @HostListener("window:scroll", []) onWindowScroll() {
    //let distance = $('thead').offset().top - $('header').offset().top;

    // let w = $(window);
    // let table_top = $('table').offset().top - w.scrollTop(); // vị trí top của bảng
    // let table_bot = $('table').offset().top + $('table').outerHeight(true) - w.scrollTop(); // vị trí bot của bảng

    // let isFix = false;
    // if ($('tbody tr').length > 0) { // nếu bảng có bản ghi thì mới fixheader
    //   if (table_top < this.top) { // khi mà top của bảng ra khỏi màn hình
    //     if ($(".fixedtable").length <= 0) {
    //       $("thead").addClass("fixedtable");
    //       isFix = true;
    //     }
    //   }
    //   else {
    //     if (table_bot < this.top || table_top > this.top) {  // khi mà bot của bảng ra khỏi màn hình hoặc khi chưa cuộn tới bảng
    //       $("thead").css("position", "relative");
    //       $("thead").removeClass("fixedtable");
    //     }
    //   }
    // }
    // if (isFix) {
    //   let listLength = [];
    //   let rowspan = $('tbody tr:nth-child(1) td:nth-child(1)').attr('rowspan');
    //   //let colsPanTd2 = $('tbody tr:nth-child(1) td:nth-child(2)').attr('colspan');
    //   let colspanTd1 = $('tbody tr:nth-child(1) td:nth-child(1)').attr('colspan');
    //   //kiểm tra xem dòng đầu tiên có phải là ghép dòng hay ko
    //   if (rowspan > 0 && rowspan != undefined) {
    //     if (listLength.length <= 0) {
    //       $('tbody tr:nth-child(2) td').each(function (index) {
    //         let item = { index: index, width: $(this).width() };
    //         listLength.push(item);
    //       });
    //     }
    //     for (let i = listLength.length - 1; i >= 0; i--) {
    //       $('thead tr th:nth-child(' + (i + 2) + ')').width(listLength[i].width);
    //       $('tbody tr:nth-child(2) td:nth-child(' + (i + 1) + ')').width(listLength[i].width);
    //     }
    //     $('thead tr th:nth-child(1)').width($('tbody tr:nth-child(1) td:nth-child(1)').width());
    //     $("thead").css("position", "fixed");
    //     $("thead").css("top", $('header').height() + "px");
    //   }
    //   else if (colspanTd1 > 0 && colspanTd1 != undefined) {
    //     if (listLength.length <= 0) {
    //       $('tbody tr:nth-child(2) td').each(function (index) {
    //         let item = { index: index, width: $(this).width() };
    //         listLength.push(item);
    //       });
    //     }
    //     this.fixThead(listLength);
    //     // let col_number = 0;
    //     // $('thead tr:nth-child(1) th').each(function (index) {
    //     //     if ($(this).attr("colspan") <= 0 || $(this).attr("colspan") == undefined) {
    //     //         col_number += 1;
    //     //     }
    //     //     $(this).width(listLength[index].width);
    //     // });
    //     // if ($('thead tr:nth-child(2) th').length > 0) {
    //     //     $('thead tr:nth-child(2) th').each(function (index) {
    //     //         $(this).width(listLength[index + col_number - 2].width);
    //     //     });
    //     // }

    //     $('tbody tr:nth-child(2) td').each(function (index) {
    //       $(this).width(listLength[index].width);
    //     });

    //     $("thead").css("position", "fixed");
    //     $("thead").css("z-index", "1000");
    //     $("thead").addClass("fixedtable");
    //     $("thead").css("top", $('header').height() + "px");
    //   }
    //   else {
    //     if (listLength.length <= 0) {
    //       $('tbody tr:nth-child(1) td').each(function (index) {
    //         let item = { index: index, width: $(this).width() };
    //         listLength.push(item);
    //       });
    //     }
    //     this.fixThead(listLength);
    //     $('tbody tr:nth-child(1) td').each(function (index) {
    //       if ($(this).attr("colspan") == undefined) {
    //         $(this).width(listLength[index].width);
    //       }
    //     });
    //     $("thead").css("position", "fixed");
    //     $("thead").css("z-index", "1000");
    //     $("thead").addClass("fixedtable");
    //     $("thead").css("top", $('header').height() + "px");
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/fixedheader.directive.ts